import React, { createContext, useContext, useState } from "react";

// Create the context
const CharacterContext = createContext();

// Create a provider component
export function CharacterProvider({ children }) {
    const [currentCharacter, setCurrentCharacter] = useState(null);

    return (
        <CharacterContext.Provider value={{ currentCharacter, setCurrentCharacter }}>
            {children}
        </CharacterContext.Provider>
    );
}

// Custom hook for easy usage
export function useCharacter() {
    return useContext(CharacterContext);
}